import { render } from "./WebhookForm.vue?vue&type=template&id=07371b18&ts=true"
import script from "./WebhookForm.vue?vue&type=script&lang=ts"
export * from "./WebhookForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__